import React, { useMemo } from "react";
import { useTable, useSortBy } from "react-table";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import PaginationAndSearching from "../../components/Pagination Component/paginationAndSearching";
import SkeletonTableRow from "../../components/SkeltonTable/skeletonTable";
import { useSelector } from "react-redux";
import { formatDate } from "../../../function/commonFunction";
import { findSubMenuByName } from "../propertyList/MenuUtlis";
//import './table.css';

export const UploadInvoicesTable = ({
  column,
  rowsArr,
  handleVerify,
  handleSearchPagination,
  searchValuePagination,
  pageSizePagination,
  handleChangeRowsPerPagePagination,
  totalCountPagination,
  handleOnChangePagination,
  showLoading,
  handleDeleteById,
}) => {
  const {permissionArr} = useSelector(state =>state.auth)
  const columns = useMemo(() => column, []);
  const data = useMemo(() => rowsArr, [rowsArr]);
  const { permissions } = useSelector(state => state.permissionsData)

  const tableInstance = useTable({ columns, data }, useSortBy);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    //footerGroups,
    rows,
    prepareRow,
  } = tableInstance;
  
    // Helper function to find a specific action in a submenu
    const hasAction = (submenu, actionName) => submenu?.Actions.includes(actionName);
    const propertiesMenu = findSubMenuByName(permissions, 'Invoice');
    const listPropertyMenu = propertiesMenu ? findSubMenuByName(propertiesMenu?.SubMenus, 'Invoice Verification') : null;
    const newSubMenu = listPropertyMenu ? findSubMenuByName(listPropertyMenu?.SubMenus, 'Pending') : null;
    const canDelete = newSubMenu ? hasAction(newSubMenu, 'Delete') : false;
    const canVerify=newSubMenu?hasAction(newSubMenu,'Verify'):false;
  
  return (
    <>

      <div className="card">
        <div className="card-header">
          <h3></h3>
          {/* <div className='pagination-search-container'>
                    <div className="service-input-group input-group">
                        <span className="input-group-text search-input-icon">

                            <i className="bi bi-search" style={{ fontSize: '16px' }}></i>
                        </span>
                        <input
                            type="text"
                            className="form-control search-input"
                            id="val-username1"
                            placeholder="Search..."
                            name="username"
                            value={searchValuePagination}
                            onChange={handleSearchPagination}
                        />
                        </div>
                    </div> */}
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <div className="dataTables_wrapper">
              <table {...getTableProps()} className="table dataTable display">
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                          style={{ color: "rgba(23, 90, 169, 0.78)" }}
                        >
                          {column.render("Header")}
                          <span className="ml-1">
                            {column.isSorted ? (
                              column.isSortedDesc ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                {/* <tbody {...getTableBodyProps()}>
								
									{rows.map((row) => {
										prepareRow(row)
										return(
											<tr {...row.getRowProps()}>
												{row.cells.map((cell) => {
													return <td {...cell.getCellProps()}> {cell.render('Cell')} </td>
												})}
												
											</tr>
										)
									})}
								</tbody> */}
                <tbody {...getTableBodyProps()}>
                  {rows.map((row, rowIndex) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell, cellIndex) => {
                          const isLastColumn =
                            cellIndex === row.cells.length - 1;
                          const secondCoulmn = cellIndex === 1;
                          // Define click handler for the last column
                          // const handleLastColumnClick = (iconIndex) => {
                          //     // Perform action based on the icon index
                          // 	console.log(rows[rowIndex])
                          //     console.log(`Clicked icon ${iconIndex} in the last column of row ${rowIndex}`);
                          // };

                          return (
                            <td
                              {...cell.getCellProps()}
                              style={{ color: "black" }}
                            >
                              {isLastColumn ? (
                                <div>
                                {canVerify &&<OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip">{"verify"}</Tooltip>
                                    }
                                  >
                                    <i
                                      className="material-icons"
                                      style={{
                                        color: "rgba(23, 90, 169, 0.78)",
                                        marginRight: "6px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        console.log(rows[rowIndex].original.Id);
                                        handleVerify(
                                          rows[rowIndex].original.Id
                                        );
                                      }}
                                    >
                                      domain_verification
                                    </i>
                                  </OverlayTrigger>}
                                  {/* <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip">{"veiw"}</Tooltip>
                                    }
                                  >
                                    <i
                                      className="material-icons"
                                      style={{
                                        color: "rgba(23, 90, 169, 0.78)",
                                        marginRight: "6px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      visibility
                                    </i>
                                  </OverlayTrigger> */}
                                  {canDelete&&
                                   <OverlayTrigger
                                   placement="top"
                                   overlay={
                                     <Tooltip id="tooltip">{"delete"}</Tooltip>
                                   }
                                 >
                                   <i
                                     className="material-icons"
                                     style={{
                                       color: "red",
                                       marginRight: "6px",
                                       cursor: "pointer",
                                     }}
                                     onClick={() => {
                                       // console.log(rows[rowIndex].original.Id);
                                       handleDeleteById(
                                         rows[rowIndex].original.Id
                                       );
                                     }}
                                   >
                                     delete
                                   </i>
                                 </OverlayTrigger>
                                  }      
                                </div>
                              ) : secondCoulmn ? (
                                formatDate(cell.value)
                              ) : (
                                cell.render("Cell")
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>{" "}
             {showLoading &&   <SkeletonTableRow cols={4} row ={4}/>}
                {/* This is only for footer if u require */}
              </table>

              {rows.length === 0 && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  No record found
                </div>
              )}

              
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {" "}
                <PaginationAndSearching
                  handleSearch={handleSearchPagination}
                  searchValue={searchValuePagination}
                  defaultValue={pageSizePagination}
                  handleChangeRowsPerPage={handleChangeRowsPerPagePagination}
                  totalCount={totalCountPagination}
                  onChange={(e,p)=>{
                    handleOnChangePagination(e,p)
                    // setCheckedRows([])
                  }}
                />
              </div>
        </div>
      </div>
    </>
  );
};
export default UploadInvoicesTable;
